import { useEffect } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import User from './pages/lead-center/User';
import AdminUser from './pages/admin/User';
import Login from './pages/Login';
import NotFound from './pages/misc/Page404';
import DashboardApp from './pages/DashboardApp';
import ComingSoon from './pages/misc/ComingSoon';
import Profile from './pages/profile/Profile';
import Details from './pages/lead-center/Details';
import PaymentGateway from './pages/PaymentGateway';
import Campaigns from './pages/campaigns/Campaigns';
import Checkout from './pages/checkout/Checkout';
import EmailTemplates from './pages/campaigns/EmailTemplates';
import CreateCampaign from './pages/campaigns/CreateCampiagn';
import CreateUser from './pages/admin/CreateUser';
import UserDetails from './pages/admin/UserDetails';
import Enquiry from './pages/admin/Enquiries';
import LandingPage from './pages/LandingPage';
import Domain from './pages/integrations/Domain';
import Hosting from './pages/hosting/Hosting';
import GoogleTag from './pages/integrations/GoogleTag';
import FbPixel from './pages/integrations/FbPixel';
import GoogleAnalytics from './pages/integrations/GoogleAnalytics';
import WhatsappWidget from './pages/integrations/WhatsappWidget';
import SmsCampaign from './pages/campaigns/SmsCampaign';
import { Services } from './pages/addons';
import Thankyou from './pages/success/Thankyou';
import AdminDashboard from './pages/AdminDashboard';
import Developer from './pages/hire/Developer';
import Hire from './pages/hire/Hire';
import DeveloperList from './pages/hire/DeveloperList';
import HeatMap from './pages/integrations/HeatMap';
import Timers from './pages/integrations/Timers';
import Websites from './pages/websites/Websites';
import HelpCenter from './pages/help/HelpCenter';
import Ticket from './pages/help/Ticket';
import Wallet from './pages/wallet/Wallet';
import Audience from './pages/audience/Audience';
import Products from './pages/Products';
import instance from './api/axiosRequest';
import { saveEmailIdentities } from './features/auth/authSlice';
import Plan from './pages/Plan';
import ExecuteCampaign from './pages/campaigns/ExecuteCampaign';
import CampaignDetails from './pages/campaigns/CampaignDetails';
// ----------------------------------------------------------------------

export default function Router() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const getEmailIdentities = async () => {
      try {
        const { data } = await instance.get('/vendor/emailIdentities');
        dispatch(saveEmailIdentities(data.data.rows));
      } catch (error) {
        console.log(error);
      }
    };
    getEmailIdentities();
  }, []);

  return useRoutes([
    {
      path: '/dashboard',
      element: user ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'admin', element: <AdminDashboard /> },
        { path: 'audiences', element: <Audience /> },
        { path: 'checkout', element: <Checkout /> },
        { path: 'success', element: <Thankyou /> },
        { path: 'plan', element: <Plan /> },
        {
          path: 'addons',
          children: [{ path: '', element: <Services /> }],
        },
        {
          path: 'specialists',
          children: [
            { path: '', element: <DeveloperList /> },
            { path: 'details/:id', element: <Developer /> },
            { path: 'hire/:id', element: <Hire /> },
          ],
        },
        { path: 'websites', element: <Websites /> },
        { path: 'hosting', element: <Hosting /> },
        {
          path: 'help',
          children: [
            { path: '', element: <HelpCenter /> },
            { path: 'submit-ticket', element: <Ticket /> },
          ],
        },
        {
          path: 'lead-center',
          children: [
            { path: '', element: <User /> },
            { path: 'details', element: <Details /> },
          ],
        },
        { path: 'enquiries', element: <Enquiry /> },
        {
          path: 'clients',
          children: [
            { path: '', element: <AdminUser /> },
            { path: 'add-user', element: <CreateUser /> },
            { path: 'details', element: <UserDetails /> },
          ],
        },
        { path: 'coming-soon', element: <ComingSoon /> },
        { path: 'profile', element: <Profile /> },
        {
          path: 'campaigns',
          children: [
            {
              path: 'campaigns',
              children: [
                { path: '', element: <Campaigns /> },
                { path: 'create', element: <CreateCampaign /> },
                { path: 'execute', element: <ExecuteCampaign /> },
                { path: 'details', element: <CampaignDetails /> },
              ],
            },
            { path: 'email-templates/:action', element: <EmailTemplates /> },
            { path: 'sms', element: <SmsCampaign /> },
          ],
        },
        {
          path: 'integration',
          children: [
            { path: 'domains', element: <Domain /> },
            { path: 'payment-gateways', element: <PaymentGateway /> },
            { path: 'google-analytics', element: <GoogleAnalytics /> },
            { path: 'google-tag', element: <GoogleTag /> },
            { path: 'fbpixel', element: <FbPixel /> },
            { path: 'whatsapp', element: <WhatsappWidget /> },
            { path: 'heatmap', element: <HeatMap /> },
            { path: 'timers', element: <Timers /> },
          ],
        },
        {
          path: 'wallet',
          element: <Wallet />,
        },
      ],
    },
    {
      path: '/',
      element: user ? <Navigate to={user.role === 1 ? '/dashboard/admin' : '/dashboard/app'} /> : <LandingPage />,
    },
    {
      path: '/products',
      element: <Products />,
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: 'admin-login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
